/**
 * Open vs closed site-distance check-in.
 *
 * Do not use `total_hours` as the gate. The Go GET payload computes elapsed
 * hours for an *open* visit, so a truthy total_hours is not "already checked out".
 * Go also serializes unset checkout coords as 0 instead of null.
 */

export function isBlankCheckoutField(value) {
  if (value == null || value === '') return true;
  const n = Number(value);
  return !Number.isNaN(n) && n === 0;
}

export function isActiveDistanceCheckin(row) {
  if (!row || typeof row !== 'object' || Array.isArray(row)) return false;

  const hasCheckin =
    row.id != null ||
    row.distance_id != null ||
    row.lat != null ||
    row.checkin_time != null ||
    row.distance_check_in_time != null;
  if (!hasCheckin) return false;

  const checkedOut =
    (row.checkout_time != null && row.checkout_time !== '') ||
    !isBlankCheckoutField(row.checkout_lat) ||
    !isBlankCheckoutField(row.checkout_long);

  return !checkedOut;
}

export function shouldShowSiteCheckinModal({
  distanceDetails,
  activeCheckin,
  siteId,
  moduleType,
} = {}) {
  if (
    activeCheckin &&
    moduleType != null &&
    String(activeCheckin.module_type) === String(moduleType) &&
    siteId != null &&
    String(activeCheckin.site_id) === String(siteId)
  ) {
    return false;
  }

  if (!isActiveDistanceCheckin(distanceDetails)) {
    return true;
  }

  if (
    siteId != null &&
    distanceDetails.site_id != null &&
    String(distanceDetails.site_id) !== String(siteId)
  ) {
    return true;
  }

  return false;
}

function matchesSiteModule(row, siteId, moduleType) {
  if (!row) return false;
  if (siteId != null && row.site_id != null && String(row.site_id) !== String(siteId)) {
    return false;
  }
  if (
    moduleType != null &&
    row.module_type != null &&
    String(row.module_type) !== String(moduleType)
  ) {
    return false;
  }
  return true;
}

export function shouldShowCheckoutButton({
  distanceDetails,
  activeCheckin,
  siteId,
  moduleType,
} = {}) {
  if (
    isActiveDistanceCheckin(distanceDetails) &&
    matchesSiteModule(distanceDetails, siteId, moduleType)
  ) {
    return true;
  }
  return (
    isActiveDistanceCheckin(activeCheckin) &&
    matchesSiteModule(activeCheckin, siteId, moduleType)
  );
}
